export const data = {
  characters: [],
  filmsData: [],
  speciesData: [],
  vehiclesData: [],
  starshipsData: [],
  planetsData: [],
  loading: false,
  error: false,
  search: null,
};
